import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import { ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { PIDService } from '../../services/pid.service';
import { PersonService } from '../../services/person.service';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';

import * as _ from 'lodash';
import { FileService } from "../../services/file.service";

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'new-pid',
  templateUrl: './new-pid.component.html',
  styleUrls: ['./new-pid.component.scss']
})
export class NestasNewPIDComponent implements OnInit {

  @Input() newPID;
  @Input() copyOf;

  types: string[];

  fileToUpload = null;
  persons = [];
  possibleParents = [];
  //rooms = [];
  pidToCopy = null;
  IAmOwner = false;
  working = false;
  type = '';
  newOwner = {
    firstname: '',
    lastname: '',
    company: '',
    email: '',
    phone: '',
    address: {
      addres: '',
      zip: null,
      city: '',
      country: ''
    }
  };

  emptyOwner = {
    _id: -1,
    firstname: '',
    lastname: '',
    company: '',
    email: '',
    phone: '',
    address: {
      addres: '',
      zip: null,
      city: '',
      country: ''
    }
  };

  putUrls = {};

  @Input() pids: any;
  @Input() parentPID;
  @Output() cancelled = new EventEmitter<Boolean>();
  @Output() done = new EventEmitter();

  sharing = {
    all: false
  };
  parentPIDFiles: any[] = [];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  roomCtrl = new FormControl();
  filteredRooms: Observable<string[]>;
  notrowspan = 1;
  rooms: string[];
  personControl: FormControl = new FormControl();
  filteredPersons;
  newOwnerLabel: string;
  putToken: string;
  printallrequested = false;

  @ViewChild('roomInput') roomInput;
  @ViewChild('auto') matAutocomplete;
  @ViewChild('newOwnerFirstname') newOwnerFirstname: ElementRef;

  isPhone = false;

  constructor(private _user: UserService, private _pidService: PIDService, private _fileService: FileService,
    private _notification: NotificationService, public translate: TranslateService,
    private _router: Router,
    private _sanitizer: DomSanitizer, private _person: PersonService) {
    this.newOwnerLabel = this.translate.instant('DATA.NEW_OWNER');
    this.filteredRooms = this.roomCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.rooms.slice()));
  }

  add(event: MatChipInputEvent): void {
    // Add rooms only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      if ((value || '').trim()) {
        this.rooms.push(value.trim());
      }

      // Reset the input value
      if (input) {
        input.value = '';
      }

      this.roomCtrl.setValue(null);
    }
  }

  remove(room: string): void {
    const index = this.rooms.indexOf(room);

    if (index >= 0) {
      this.rooms.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.rooms.push(event.option.viewValue);
    this.roomInput.nativeElement.value = '';
    this.roomCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.rooms.filter(room => room.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit() {
    this.isPhone = window.matchMedia('(max-width: 767px)').matches;

    //console.log("new / edit / copy", this.copyOf);

    this.types = [];
    this._pidService.getPIDTypes()
      .subscribe((response: any) => {
        this.types = response.types;
      }, (error: any) => {
        console.log(error);
      });


    //  If there is parentPID fetch its files. This is only required when creating or editing
    //  PIDs
    //console.log("sub sharing", this.copyOf, this.parentPID, this.parentPID._id);
    if (!this.copyOf && this.parentPID && this.parentPID._id) {

      var lastSubPIDId = null;

      if (this.parentPID.children && this.parentPID.children.all) {
        lastSubPIDId = (_.last(this.parentPID.children.all) || {})._id;
      }

      this._fileService.getFromPID(this.parentPID._id)
        .subscribe(files => {
          if (this.newPID && this.newPID._id) {
            this.parentPIDFiles = _.map(files, file => {
              return {
                fileId: file._id,
                name: file.name,
                sharedWith: this.newPID._id && _.indexOf(file.sharing, this.newPID._id) > -1
              };
            });
          } else {
            this.parentPIDFiles = _.map(files, file => {
              return {
                fileId: file._id,
                name: file.name,
                sharedWith: lastSubPIDId && _.indexOf(file.sharing, lastSubPIDId) > -1
              };
            });
          }

          this.sharing.all = _.every(this.parentPIDFiles, fileSharing => {
            return fileSharing.sharedWith;
          });
        },
          this._notification.errorServer
        );
    }

    this._initNewPID();
    this._getPersons();

    if (this.pids && this.pids.length > 0) {
      this.possibleParents = _.filter(this.pids, p => {
        return (!p['copy'] && !p['template']);
      })
    } else {
      this.possibleParents = []
    }
  }

  selectAll() {
    if (this.parentPID && this.parentPIDFiles) {
      _.forEach(this.parentPIDFiles, sharing => {
        sharing.sharedWith = this.sharing.all;
      });
    }
  }

  checkKey(e) {
    if (e.keyCode == 9) {
      this.addRoom();
    }
  }

  addRoom() {
    this.rooms.push('');
  }

  private _getPersons() {
    this._person.getMine()
      .subscribe(
        (persons: any) => {
          this.persons = [this.emptyOwner].concat(persons);
          this.filteredPersons = this.personControl.valueChanges.pipe(
            startWith(null),
            map((val: string) => val && val.length >= 1 ? this.personAutocompleteFilter(this.persons, val) : this.persons.slice(0, 5)));
        },
        this._notification.errorServer
      )
  }

  private _initNewPID() {

    //  edit
    if (_.get(this.newPID, '_id')) {
      this.newPID.construction = this.newPID.construction ? this.newPID.construction.split('T')[0] : null;
      if (this.newPID.owner) {
        this.IAmOwner = false;
        this.newOwner = this.newPID.owner;
      } else {
        this.newPID.owner = this.emptyOwner;
      }

      this.rooms = _.map(this.newPID.rooms, r => {
        return r;
      });

      return;
    }

    if (this.parentPID) {
      this.newPID = {
        name: '',
        address: this.parentPID.address,
        type: "Flat", // Appartment
        shortDescription: '',
        construction: this.parentPID.construction ? this.parentPID.construction.split('T')[0] : null,
        parentPID: this.parentPID['_id'],
        owner: (this.parentPID.owner ? this.parentPID.owner._id || this.parentPID.owner : -1)
      };
      console.log("new pid parent pid owner", this.newPID, this.parentPID.owner);
    } else {
      let today = new Date();
      this.newPID = {
        name: '',
        address: { address: '', zip: null, city: '', country: '' },
        type: "House",
        shortDescription: '',
        construction: [
          today.getFullYear(),
          (today.getMonth() + 1 < 10) ? "0" + (today.getMonth() + 1) : (today.getMonth() + 1),
          today.getDate() >= 10 ? today.getDate() : "0" + (today.getDate())
        ].join('-'),
        parentPID: null,
        owner: -1,
      };
    }

    if (!this.newPID.img) {
      this.newPID.img = { url: '' };
    }

    this.rooms = [];

    if (this.copyOf && this.copyOf._id) {
      this._copy();
    }
  }

  private _copy() {
    let tmp = _.find(this.pids, (h) => {
      return h['_id'] == this.copyOf._id
    });
    console.log("_copy", tmp);

    if (tmp) {
      this.newPID.construction = tmp['construction'] ? tmp['construction'].split('T')[0] : null;
      this.rooms = _.map(tmp['rooms'], r => {
        return r;
      });
      this.newPID.address = tmp['address'];
      if (tmp['owner'] && tmp['owner']['_id']) {
        this.IAmOwner = false;
        this.newPID.owner = tmp['owner'];
        this.newOwner = tmp['owner'];
      }
      this.newPID.construction = tmp['construction'] ? tmp['construction'].split('T')[0] : null;
      this.newPID.type = tmp['type'];
      this.newPID.name = tmp['name'];
      this.newPID.img = JSON.parse(JSON.stringify(tmp['img']));
      this.newPID.shortDescription = tmp['shortDescription'];
      this.newPID.copyFrom = this.copyOf._id;
    }
  }

  cancel() {
    this.cancelled.emit(true);
  }

  printAll(id) {
    console.log("print all", id);
    this.printallrequested = true;
    this.newPID.printall = this.newPID.printall || {};
    this.newPID.printall.requestedBy = this._user.me();
    this._pidService.printAll(id).subscribe(x => {
      console.log("print all init", x);
      /*this.putUrls = x['putUrls'];
      this.putToken = x['putToken'];*/
    });
  }

  completePrint(id, token) {
    console.log("complete print", id, token);
    this._pidService.completePrint(id, token).subscribe(x => {
      console.log("complete print ack", x);
    });
  }

  subOff(id) {

    let tmp = _.find(this.pids, (h) => {
      return h['_id'] == id
    });

    if (tmp) {
      this.newPID.parentPID = id;
      this.newPID.address = tmp['address'];
      if (tmp['owner'] && tmp['owner']['_id']) {
        this.IAmOwner = false;
        this.newPID.owner = tmp['owner'];
        this.newOwner = tmp['owner'];
      }
      this.newPID.construction = tmp['construction'] ? tmp['construction'].split('T')[0] : null;
      this.newPID.type = 'Appartment';
    } else {
      this._initNewPID();
    }
  }

  updatePreview(event) {
    if (this.newPID.img.url.startsWith('/assets/')) {
      this.newPID.img.url = '/assets/' + event.target.value + '.png';
    }
  }

  fallbackImg($event) {
    this.newPID.img.url = '/assets/' + this.newPID.type + '.png';
    $event.target.src = '/assets/' + this.newPID.type + '.png';
  }

  fileChangeEvent(fileInput) {
    var file = fileInput.target.files[0];
    this.fileToUpload = fileInput.target.files[0];
    var reader = new FileReader();
    var _self = this;

    reader.addEventListener("load", function () {
      if (!_self.newPID.img) {
        _self.newPID.img = { url: '' }
      }
      _self.newPID.img.url = _self._sanitizer.bypassSecurityTrustUrl(reader.result as string);
    }, false);

    reader.readAsDataURL(this.fileToUpload);
    this.newPID.file = { type: file.type, name: file.name }
  }

  formatPerson(p) {
    //console.log("format person", p, p._id, p._id == -1);
    if (!p || p == -1 || p._id == -1) {
      return this.newOwnerLabel;
    }
    let res = "";

    if (!p) return res;
    if ((p.firstname && p.firstname.trim()) || (p.lastname && p.lastname.trim())) {
      res += p.firstname.trim() + ' ' + p.lastname.trim();
    } else {
      res += p.company;
    }
    res += p.email ? ' (' + p.email + ')' : '';
    return res;
  }

  setIAmOwner($e) {

    if (!$e.checked && this.IAmOwner) {
      this.newPID.owner = { _id: "-1" };
    }

    this.IAmOwner = $e.checked;
    this.newPID.owner = this.IAmOwner ? null : {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      address: {
        addres: '',
        zip: null,
        city: '',
        country: ''
      },
      _id: _.get(this.newPID, 'owner._id', '-1')
    };
  }

  setNewOwner($e) {
    console.log("set new owner", $e);
    this.newOwnerFirstname.nativeElement.focus();
    this.newOwner = _.find(this.persons, p => {
      return $e.option.value._id != -1 && p._id == $e.option.value._id
    })
      || {
      firstname: '',
      lastname: '',
      email: '',
      company: '',
      phone: '',
      address: {
        addres: '',
        zip: null,
        city: '',
        country: ''
      }
    };
  }

  private _updatePID(pid) {
    delete pid.owner;
    this.newPID = _.merge(this.newPID, pid);
  }

  getContractorRowHeight() {
    return 135;
  }

  roomRowSpan() {
    let span = (this.rooms.length / 10) - 1;
    if (span < 2) {
      return 2;
    }
    return span;
  }

  addPID(callback) {

    if (this.newPID.owner && (this.newPID.owner.firstname || this.newPID.owner.lastname || this.newPID.owner.company) && !this.newPID.owner.email) {
      this._notification.errorServer(this.translate.instant('MESSAGE.ERROR.OWNER_EMAIL_REQUIRED'));
      return;
    }

    if (this.copyOf && this.copyOf.sharedWith && !(this.newPID && this.newPID._id) && this._user.me()['_id'] == this.copyOf.sharedWith._id) {
      // shared but now owned, we cannot duplicate the parent, so we make the new PID orphaned
      this.newPID.parentPID = undefined;
    }
    this.working = true;

    this.newPID.owner = this.IAmOwner ? null : this.newOwner;

    if (this.newPID.img && this.newPID.img.url && this.fileToUpload) {
      delete this.newPID.img.url;
    }

    this.newPID.rooms = _.map(_.filter(this.rooms, r => {
      return r;
    }), r => {
      return r;
    });
    //console.log("save / add pid", this.newPID.owner, this.newOwner, "cb", callback);

    var ownerObject = JSON.parse(JSON.stringify(this.newPID.owner)); // clone

    //  Add file sharing information
    this.newPID.fileSharing = this.parentPIDFiles;
    if (this.newPID.owner == -1) {
      this.newPID.owner = null;
    }

    console.log("saving PID, owner", this.newPID, "new owner", this.newOwner);

    return this._pidService.addPID(this.newPID, this._user.me()['_id']).subscribe(
      (ret: any) => {
        //console.log("ret", ret);
        this.cancel();
        this._initNewPID();
        if (this.fileToUpload && ret.url) {
          this._pidService.uploadImg(ret.url, this.fileToUpload).subscribe(
            success => {
              if (!this.IAmOwner)
                this._getPersons();
              this._pidService.get(ret.pid._id).subscribe(pid => {
                this.pids.push(pid);
                this._updatePID(pid);
                this.working = false;
                this._notification.success('MESSAGE.SUCCESS', ' ');
                this._initNewPID();
                this.done.next();
                ret.pid.owner = ownerObject;
                ret.pid.PIDOwner = this._user.me();//this.newPID.PIDOwner;
                if (callback) callback();
              });

            }, err => {
              this.working = false;
            }
          );
        } else {
          if (!this.IAmOwner)
            this._getPersons();
          this._pidService.get(ret.pid._id).subscribe(pid => {
            this.pids.push(pid);
            this._updatePID(pid);
            this.working = false;
            this._notification.success('MESSAGE.SUCCESS', ' ');
            this._initNewPID();
            this.done.next();
            ret.pid.owner = ownerObject;
            ret.pid.PIDOwner = this._user.me();//this.newPID.PIDOwner;
            if (callback) callback();
          });
        }

      },
      err => {
        console.log("error adding pid", err);
        if (err) this._notification.errorServer(err.error);
        this.working = false;
        this._initNewPID();
        this.done.next();
      }
    );
  }

  printAllowed() {
    return true;
    //return this._user.isAdmin() || ['_BAVS', '_VESTAD', '_TW'].indexOf(this._user.me().company) != -1;
  }

  changePIDOwnerAllowed() {
    //console.log("check pidowner", this._user.me()['_id'], this.newPID.PIDOwner['_id'], this._user.me()['_id'] != this.newPID.PIDOwner['_id']);
    return this.newPID && this.newPID._id && this._user.me().company && this._user.me()['_id'] != this.newPID.PIDOwner['_id'];
  }

  changePIDOwner(pidId){
    this._pidService.changeOwner(pidId, {profile: this._user.me()['_id']}).subscribe(x => {
      console.log("switched", x);
      this._notification.success('MESSAGE.SUCCESS', ' ');

      // make sure the notification is visible
      setTimeout(() => this._router.navigate(['']).then(() => {
        window.location.reload();
      }), 2000);
      
    });
  }

  personAutocompleteFilter(list, val: string) {
    var lc = val.toLowerCase();
    //console.log("person acw", list);
    var res = list.filter(option => (!lc.length
      || (option.firstname && option.firstname.toLowerCase().indexOf(lc) > -1)
      || (option.lastname && option.lastname.toLowerCase().indexOf(lc) > -1)
      || (option.company && option.company.toLowerCase().indexOf(lc) > -1)
    ));
    return res;
  }


}
